import { Box, TextField } from '@citibox-panel/ui';
import { REASON_MAX_LENGTH } from '../lib/reason';

// TODO: i18n — copy en ES hasta Fase 1.
const HINT = 'Obligatorio. Puedes incluir el ticket de Zendesk.';

export interface ReasonFieldProps {
  value: string;
  onChange: (value: string) => void;
  autoFocus?: boolean;
}

// The «Motivo» every courier account action asks for, in one place so the three dialogs cannot
// drift apart. The count is there because the cap cuts a long paste silently, and the end of a
// reason is usually the Zendesk ticket; it counts what is written, which is what the cap limits.
export function ReasonField({ value, onChange, autoFocus = false }: ReasonFieldProps) {
  return (
    <TextField
      label="Motivo"
      required
      multiline
      rows={3}
      fullWidth
      maxLength={REASON_MAX_LENGTH}
      autoFocus={autoFocus}
      value={value}
      onChange={onChange}
      helperText={
        // A span, not a div: MUI renders the helper text as a <p>.
        <Box component="span" sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
          <span>{HINT}</span>
          <span>{`${String(value.length)}/${String(REASON_MAX_LENGTH)}`}</span>
        </Box>
      }
    />
  );
}
